import { FormControl, FormLabel, Grid } from "@mui/material";
import React, { useEffect, useState, memo, useCallback } from "react";
import TextInput from "../common/textInput/TextInput";
import { SelectView } from "../common/selectView/SelectView";
import {
  HELPER_TEXT_STYLE,
  MARGIN_TB_ITEMS_SM,
  Name_Validation,
  NUMBER_FIELD_STYLE,
  RIGHT_ALIGN,
  SUCCESS_TXT,
} from "../../utils/GlobalConstants";
import { FLEET_CREATION_FORM_VALUES } from "../../utils/GlobalFormConstants";
import {
  CHAR_ERR,
  DATA_MISS,
  NO_FlEET_SELECTION,
} from "../../utils/GlobalMessageConstants";
import { useDispatch, useSelector } from "react-redux";
import {
  addItemInFleetData,
  addItemInsurveyData,
} from "../../store/UpdateSurveyData";
import Typo from "../common/typo/Typo";
import {
  getMessages,
  getSelectedState,
  getStatesByCountry,
  onChangeFormInfo,
} from "../../utils/genericUse/CommonUse";
import {
  createFleet,
  createSurvey,
  deleteSingleFleet,
  fetchAllFleets,
  getSingleFleet,
  getSingleSurveyDetails,
} from "../../services/SurveyRequest";
import ButtonLayout from "./ButtonLayout";
import Loader from "../../components/common/dialog/Loader";
import { useTranslation } from "react-i18next";

const FleetCreationForm = (props) => {
  const [fleetList, setFleetList] = React.useState();
  const [states, setStates] = React.useState();
  const [selectedCountry, setSelectedCountry] = React.useState({
    id: 1,
    name: "USA",
  });
  const [selectedState, setSelectedState] = React.useState();
  const [fleet, setFleet] = React.useState();
  const [selectedFleet, setSelectedFleet] = useState(false);
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = React.useState("");
  const [helperEmailText, setHelperEmailText] = React.useState();
  const [emailError, setEmailError] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedSurvey, setSelectedSurvey] = useState("");
  const [countries, setCountries] = useState();
  const [errorInfo, setErrorInfo] = useState({
    fleetName: { text: DATA_MISS, isTrue: false },
    arNo: { text: DATA_MISS, isTrue: false },
  });
  const dispatch = useDispatch();
  const { t } = useTranslation();


  const selectedSurveyFromStore = useSelector(
    (state) => state.surveyData?.surveyData
  );

  const countriesFromStore = useSelector(
    (state) => state.surveyData?.countryData?.countries
  );
 

  useEffect(() => {
    getAllFleets();
  }, []);

  useEffect(() => {
    setSelectedSurvey(selectedSurveyFromStore);
  }, [selectedSurveyFromStore]);

  useEffect(() => {
    setCountries(countriesFromStore);
    if (countriesFromStore && countriesFromStore.length > 0) {
      setStates(countriesFromStore[0].states);
    }
  }, [countriesFromStore]);

  const getFleet = useCallback(
    async (id) => {
      try {
        const getFleetData = await getSingleFleet(id);
        setFleet(getFleetData.fleet);
        let tempStates;
        if (getFleetData.fleet.country) {
          let updatedCountryStatesInfo = getStatesByCountry(
            countries,
            getFleetData.fleet.country
          );
          setSelectedCountry(updatedCountryStatesInfo.selectedCountry);
          tempStates = updatedCountryStatesInfo.tempStates;
          setStates(updatedCountryStatesInfo.tempStates);
        }
        if (getFleetData.fleet.state) {
          let tempSelectedState = getSelectedState(
            tempStates,
            getFleetData.fleet.state
          );
          setSelectedState(tempSelectedState);
        }
       
      } catch (e) {
        console.log(e);
      }
    },
    [countries]
  );

  useEffect(() => {
    clearingForm();
    if (selectedSurvey && Object.keys(selectedSurvey).length === 0) {
      setFleet({});
      setSelectedState({});
    } else if (selectedSurvey && selectedSurvey.fleetId) {
      getFleet(selectedSurvey.fleetId);
      setSelectedFleet(true);
    } else {
     
    }
    
  }, [selectedSurvey, getFleet]);

  const getAllFleets = async () => {
    try {
      const getFleetList = await fetchAllFleets();
      let fleets = [
        { id: "Add New", fleetName: "Add New" },
        ...getFleetList.fleets,
      ];
      setFleetList(fleets);
    } catch (e) {
      console.log(e);
    }
  };

  const clearingForm = () => {
    setEmailError(false);
    setHelperText("");
    setHelperEmailText("");
    setError(false);
  };

  const onHandleChangeUser = (id) => {
    setSuccessMsg("");
    setSelectedFleet(true);
    setSelectedState({});
    if (id !== "Add New") {
      getFleet(id);
    } else {
      setFleet({ id: "Add New", fleetName: "" });
    }
  };

  const onHandleChangeStates = (id) => {
    setSelectedState({ id: id, name: states[id - 1].name });
  };

 
  const onchangeText = (e, type) => {
    let value = e.target.value;

    if (type === "arNo") {
      if (/^[0-9]*$/.test(value)) {
        setFleet((fleet) => ({ ...fleet, [type]: value }));
        setErrorInfo((prev)=>({
          ...prev,
          arNo: { text: DATA_MISS, isTrue: false },
        }));
      }
       else {
      
       setErrorInfo((prev)=>({
        ...prev,
        arNo:{text:CHAR_ERR,isTrue:true}
       }))
      }
      return;
    }
    if (type === "fleetName") {
       const regex = /^[A-Za-z0-9 _-]*$/;
      
        
      
        if (regex.test(value)) {
          setErrorInfo({
        ...errorInfo,
        fleetName: { text: DATA_MISS, isTrue: false },
      });
        } else {
            setErrorInfo({
        ...errorInfo,
        fleetName: { text: Name_Validation, isTrue: true },
      });
        }
     
    }
    let updatedInfo = onChangeFormInfo(
      e,
      type,
      fleet,
      helperText,
      "",
      helperEmailText,
      error,
      emailError,
      false
    );
    setFleet((fleet) => ({ ...fleet, ...updatedInfo.tempJobber }));
    setError(updatedInfo.error);
    setHelperText(
      updatedInfo.helperText
        ? t("tab1.messages.AR_valid_msg")
        : updatedInfo.helperText
    );
    setHelperEmailText(
      updatedInfo.helperEmailText
        ? t("tab1.messages.email_valid_msg")
        : updatedInfo.helperEmailText
    );
    setEmailError(updatedInfo.emailError);
    setSuccessMsg("");
  };
  //===

  const handleBlur = (e, type) => {
    if (type === "arNo") {
      setError((prev) => ({ ...prev, [type]: "" }));
      let value = e.target.value;
      if (value) {
        value = value.padStart(5, "0");
        setFleet((fleet) => ({ ...fleet, [type]: value }));
      }
    }
  };



  const saveFleet = async () => {
    let payload = {
      ...fleet,
      country:
        selectedCountry && selectedCountry.name ? selectedCountry.name : "",
      state: selectedState && selectedState.name ? selectedState.name : "",
      id: fleet.id === "Add New" ? null : fleet.id,
    };

    let err = { fleet: false, arNo: false };
    if (!payload.fleetName || payload.fleetName.length === 0) {
      setError(true);
      err.fleet = true;
    }
    if (!payload.arNo || payload.arNo.length === 0) {
      setError(true);
      err.arNo = true;
    }
    if (Object.values(err).some((val) => val === true)) {
      setErrorInfo({
        fleetName: { ...errorInfo.fleetName, isTrue: err.fleet },
        arNo: { ...errorInfo.arNo, isTrue: err.arNo },
      });
    } else if (helperEmailText && helperEmailText.length > 0) {
      setEmailError(true);
    }
    //===
    else {
      setError(false);
      setEmailError(false);
      setErrorInfo({});
      try {
        setLoading(true);
        const saveFleetData = await createFleet(payload);
        
        dispatch(addItemInFleetData(payload));
        getAllFleets();
        getFleet(saveFleetData.data.id);
        if (
          Object.keys(selectedSurvey).length === 0 &&
          selectedSurvey.constructor === Object
        ) {
          setLoading(false);
          setSuccessMsg(saveFleetData.data.message);
          clearMsg();
        } else {
       
          let FleetWithSurvey = {
            ...selectedSurvey,
            fleetId: saveFleetData.data.id,
            surveyType: 1,
            vehicles: [],
          };
          const associateResponse = await createSurvey(FleetWithSurvey);
         
          const afterAssociation = await getSingleSurveyDetails(
            associateResponse.data.id
          );
          setLoading(false);
          dispatch(addItemInsurveyData(afterAssociation.survey));
          
          setSuccessMsg(t("tab1.messages.fleet_asso_msg"));
          clearMsg();
        }
      } catch (e) {
        setLoading(false);
        alert(
          Array.isArray(e.response.data?.message)
            ? JSON.stringify(e.response.data?.message[0])
            : JSON.stringify(e.response.data?.message)
        );
      }
    }
  };

  const clearMsg = () => {
    setTimeout(() => {
      setSuccessMsg("");
    }, 3000);
  };

  const deleteFleet = async () => {
    if (!fleet?.id || fleet?.id === "Add New") {
      alert(NO_FlEET_SELECTION);
    } else {
      if (window.confirm(t("tab1.messages.fleet_delete_msg"))) {
        try {
          setLoading(true);
          await deleteSingleFleet(fleet.id);
          setFleet({ fleetName: "" });
          setSelectedFleet(null)
          setSelectedState({});
          setLoading(false);
          getAllFleets();
        } catch (e) {
          console.log(e);
          setLoading(false);
        }
      }
    }
  };

  return (
    <FormControl fullWidth>
      {FLEET_CREATION_FORM_VALUES.map((data, index) => {
        return (
          <React.Fragment key={index}>
            {data?.fieldType === "select" && data?.key === "existingFleets" && (
              <SelectView
                label={data?.label}
                onHandleChange={(item) => onHandleChangeUser(item)}
                testid={data?.testid}
                data={data.key === "existingFleets" && fleetList}
                value={
                  data?.key === "existingFleets" && fleet && fleet.id
                    ? fleet.id
                    : ""
                }
              />
            )}

            {data.fieldType === "TextField" && data.key !== "selectCountry" && (
           <> <FormLabel
                htmlFor={data?.label}
                sx={{
                  color:  !!error[data.key] ||
                  !!errorInfo[data.key]?.isTrue ? "error.main" : "text.primary",
                  "& .required-asterisk": {
                    color:  !!error[data.key] ||
                  !!errorInfo[data.key]?.isTrue ? "error.main" : "inherit",
                  },
                }}
              >
                {data?.label}
                {   data?.required &&<span className={"required-asterisk"}> <i>(Required *)</i></span>}
              </FormLabel>
              <TextInput
              
                onChange={(e) => onchangeText(e, data.key)}
                onBlur={(e) => handleBlur(e, data.key)}
               label={data?.label}
                value={fleet && fleet[data.key] ? fleet[data.key] : ""}
                error={
                  !!error[data.key] ||
                  !!errorInfo[data.key]?.isTrue }
                helperText={
                  error[data.key] || errorInfo[data.key]?.isTrue
                    ? errorInfo[data.key]?.text
                    : ""
                }
                inputProps={data?.inputProps}
                disabled={selectedFleet ? false : true}
                type={data?.type}
                sx={data?.type === "number" && NUMBER_FIELD_STYLE}
                required={data?.required ? true : false}
                data-testid={data.key}
              /></>
            )}
            {data?.fieldType === "TextField" && data?.key === "selectCountry" && (
              <><FormLabel
                              htmlFor={"selectCountry"}
                              sx={{
                                color:  "text.primary",
                               
                              }}
                            >
                              {data?.label}
                             
                            </FormLabel>
              <TextInput
               label={data?.label}
                defaultValue={selectedCountry && selectedCountry.name}
                InputProps={{
                  readOnly: true,
                }}
                disabled={selectedFleet ? false : true}
              /></>
            )}
            {data?.fieldType === "select" && data?.key === "selectStates" && (
              <SelectView
                data={states}
                label={data?.label}
                testid={data?.testid}
                onHandleChange={(item) => onHandleChangeStates(item)}
                value={
                  selectedState && selectedState.id ? selectedState.id : ""
                }
                disabled={selectedFleet ? false : true}
              />
            )}
          </React.Fragment>
        );
      })}

      <Grid container sx={MARGIN_TB_ITEMS_SM}>
        {/* helper text display for warning/errors -start */}
        <Grid item md={6} lg={6} xs={12} sm={12}>
          {getMessages(fleet, helperText, "", helperEmailText, successMsg).map(
            (item, index) => {
              return (
                <Typo
                  key={index}
                  text={item.helperText}
                  style={
                    item.type === "success"
                      ? { ...HELPER_TEXT_STYLE, ...SUCCESS_TXT }
                      : HELPER_TEXT_STYLE
                  }
                />
              );
            }
          )}
        </Grid>
        {/*  helper text display for warning/errors -end */}
        <Grid item md={6} lg={6} xs={12} sm={12}>
          <div style={{ ...RIGHT_ALIGN }}>
            <ButtonLayout
              saveLabel={"Save"}
              onClickSave={() => saveFleet()}
              saveDisabled={selectedFleet ? false : true}
              saveTestID={"save"}
              deleteLabel={"Delete"}
              deleteDisabled={
                !(selectedFleet && fleet?.id && fleet?.id !== "Add New") 
              }
              deleteOnClick={() => deleteFleet()}
              deleteTestId={"delete"}
            />
          </div>
        </Grid>
      </Grid>
      {loading && (
        <Loader data-testid="loading-sppiner-id" className="Loader-style" />
      )}
    </FormControl>
  );
};
export default memo(FleetCreationForm);
